import { Col, Row } from 'reactstrap';
import Layout from '../../components/Layout/Layout';
import Routes from '../../helpers/Routes';
import { BigButton } from '../workshop/BigButton';

export default function Workshop() {

    return (
        <Layout>
            <Row style={{ justifyContent: "center", alignItems: "center" }}>
                <Col xl={2} lg={2} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
                    <BigButton
                        path={Routes.kpis.details}
                        label={"Registos com dia de início diferente do dia de fim"}
                    />
                </Col>

                <Col xl={2} lg={2} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
                    <BigButton
                        path={Routes.kpis.create}
                        label={"Registos com tempo total de assistência maior do que 7h"}
                    />
                </Col><Col xl={2} lg={2} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
                    <BigButton
                        path={Routes.kpis.list2}
                        label={"Lista Marcas/Modelo"}
                    />
                </Col>
                <Col xl={2} lg={2} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
                    <BigButton
                        path={Routes.kpis.list3}
                        label={"Assistências com registos em aberto"}
                    />
                </Col>
                <Col xl={2} lg={2} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
                    <BigButton
                        path={Routes.kpis.list4}
                        label={"Assistências por fechar com mais de 10 dias"}
                    />
                </Col>
                <Col xl={2} lg={2} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
                    <BigButton
                        path={Routes.kpis.list5}
                        label={"Dashboard de Técnicos"}
                        // onClickFunction={async () => {
                        //     window.open(Routes.kpis.list5, "_blank");
                        // }}
                    />
                </Col>
                <Col xl={2} lg={2} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
                    <BigButton
                        path={Routes.kpis.list6}
                        label={"Dashboard de Clientes"}
                    />
                </Col>
                
            </Row>
        </Layout>
    )
}